import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IObjectivesRetirementFormState } from '../../../store/objective.state';
import { setObjectiveRetirementAction } from '../../../store/objective.actions';
import { getObjectiveRetirementSelectors } from '../../../store/objective.selectors';
import { GoalsService } from 'src/app/services/goals.service';
import { getCookie } from 'src/app/utils/get-cookie';
import { IRetirementGoalBody, IRetirementGoalResponse } from 'src/app/modules/interfaces/retirement-dto.interface';

@Component({
  selector: 'app-retirement',
  templateUrl: './retirement.component.html',
  styleUrls: ['./retirement.component.scss'],
})
export class RetirementComponent implements OnInit {
  @Input() data: IRetirementGoalResponse;
  selectedGoals: number[] = [];
  formsId: number = 0

  check: number = 0
  isLoading: boolean = false;
  buttonText: string = "Salvar";

  panelOpenState = true;
  dataStoreRetirement$: Observable<any>;
  dataStoreRetirement: IObjectivesRetirementFormState;
  currentYear: number = 0;
  forecastYear: number = 0;

  constructor(
    private store: Store,
    private readonly goalsService: GoalsService
  ) {
    this.formsId = Number(getCookie('formsId'))
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.loadSelectedGoals()
    this.retirementCalculation();
    this.getState();
    this.setValuesForm();
    this.saveState()
    
  }

  loadSelectedGoals(){
    this.goalsService.getSelectedGoals(this.formsId).subscribe((res: any)=> {
      this.selectedGoals = res.data || []
      
    })
  }

  retirementCalculation(): void {
    if (this.data.current_age && this.data.retirement_age) {
      this.data.retirement_year = this.currentYear + (this.data.retirement_age - this.data.current_age);
    }
  }
  
  setState(data: IObjectivesRetirementFormState) {
    this.store.dispatch(setObjectiveRetirementAction(data));
  }

  getState(): void {
    this.dataStoreRetirement$ = this.store.select(
      getObjectiveRetirementSelectors
    );

    this.dataStoreRetirement$.subscribe((value) => {
      this.dataStoreRetirement = {
        ...(this.dataStoreRetirement = value),
      };
    });
  }

  setValuesForm(): void {
    const isComplete =
      !!this.data.motive &&
      !!this.data.current_age &&
      !!this.data.retirement_age &&
      !!this.data.retirement_year &&
      !!this.data.investment_max;
  
    this.check = isComplete ? 1 : 0;
    this.dataStoreRetirement.check = isComplete;
  }
  
  updateInvestmentAmount(type: 'min' | 'max', event: any): void {
    if (type === 'min') {
      this.data.investment_min = event;
    } else {
      this.data.investment_max = event;
    }
    this.setValuesForm();
  }
  
  saveForm() {
    const goalData: IRetirementGoalBody = {
      check: this.check,
      motive: this.data.motive,
      investment_min: this.data.investment_min,
      investment_max: this.data.investment_max,
      observation: this.data.observation,
      addictional_fields: {
        current_age: this.data.current_age,
        retirement_year: this.data.retirement_year,
        retirement_age: this.data.retirement_age,
      },
    };

    this.isLoading = true;
    this.buttonText = "Salvando...";

    this.goalsService.updateGoals(this.formsId, this.data.id, goalData)
    .subscribe({
      next: () =>{ this.panelOpenState = false
        this.saveState()
        this.isLoading = false;
          this.buttonText = "Salvar";
      }, 
      error: (err) =>{ 
        console.error('Erro ao salvar', err)
        this.isLoading = false;
        this.buttonText = "Salvar";
      }
      
    });
  }

  saveState() {
    this.dataStoreRetirement = {
      ...this.dataStoreRetirement,
      isSelected: true,
      check: Boolean(this.check),
      description: this.data.motive,
      minimumInvestment: this.data.investment_min,
      maximumInvestment: this.data.investment_max,
      observation: this.data.observation,
      currentAge: this.data.current_age,
      yearIntention: this.data.age_to_intend_retire,
      forecastYear: this.data.retirement_year,
    }
    this.setState(this.dataStoreRetirement)
  }

  UpdateGoals(){
    this.goalsService.createGoals(this.formsId, this.selectedGoals).subscribe(() => {
      this.dataStoreRetirement = {
        ...this.dataStoreRetirement,
        isSelected: !this.dataStoreRetirement.isSelected,
      };
      this.setState(this.dataStoreRetirement);
      window.location.reload();
    });
  }

  unCheck(): void {
    const goalId = 1
    this.selectedGoals = this.selectedGoals.filter((id) => id !== goalId);
    this.UpdateGoals()
    
  }
}
